// This linter exception is needed because we are using this as a component but we are returning null, so the linter thinks it's not a React component
// eslint-disable-next-line no-unused-vars
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

import {isIntegrationDomain} from '@stubhub/supported-domains';

const ReloadPage = ({location}) => {
  useEffect(() => {
    reload(location);
  }, [location]);

  return null;
};

ReloadPage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};

const reload = (loc) => {
  if (typeof window !== 'undefined' && window && window.location) {
    const u = `${loc.pathname}${loc.search}`;
    if (isIntegrationDomain(window.location.host)) {
      window.history.replaceState({reload: 1}, '', '?reload=1');
      window.location.replace(u);
    } else {
      window.location.replace(`https://www.stubhub.ie${u}`);
    }
  }
};

export default ReloadPage;
